import React from 'react';
import { Card, CardContent, Grid, TextField, Typography, Box, Button } from '@mui/material';
import { FolderOpen as FolderIcon } from '@mui/icons-material';

interface GeneralSettingsTabProps {
    facebookUrl: string;
    instagramUrl: string;
    reviewUrl: string;
    practiceName: string;
    logoImage: string;
    backgroundImage: string;
    onFacebookUrlChange: (value: string) => void;
    onInstagramUrlChange: (value: string) => void;
    onReviewUrlChange: (value: string) => void;
    onPracticeNameChange: (value: string) => void;
    onLogoImageChange: (value: string) => void;
    onBackgroundImageChange: (value: string) => void;
    onOpenFileManager: (target: 'logo' | 'background') => void;
}

export const GeneralSettingsTab: React.FC<GeneralSettingsTabProps> = ({
    facebookUrl,
    instagramUrl,
    reviewUrl,
    practiceName,
    logoImage,
    backgroundImage,
    onFacebookUrlChange,
    onInstagramUrlChange,
    onReviewUrlChange,
    onPracticeNameChange,
    onLogoImageChange,
    onBackgroundImageChange,
    onOpenFileManager
}) => {
    return (
        <Box>
            {/* Social Media Links */}
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Social Media Links
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Facebook URL"
                                value={facebookUrl}
                                onChange={(e) => onFacebookUrlChange(e.target.value)}
                                placeholder="https://facebook.com/..."
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Instagram URL"
                                value={instagramUrl}
                                onChange={(e) => onInstagramUrlChange(e.target.value)}
                                placeholder="https://instagram.com/..."
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Review URL"
                                value={reviewUrl}
                                onChange={(e) => onReviewUrlChange(e.target.value)}
                                placeholder="https://reviews.example.com/..."
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* Branding */}
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Branding
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Practice Name"
                                value={practiceName}
                                onChange={(e) => onPracticeNameChange(e.target.value)}
                                placeholder="Enter your practice name"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <TextField
                                    fullWidth
                                    label="Logo Image Filename"
                                    value={logoImage}
                                    onChange={(e) => onLogoImageChange(e.target.value)}
                                    placeholder="Select or enter filename"
                                />
                                <Button
                                    variant="outlined"
                                    startIcon={<FolderIcon />}
                                    onClick={() => onOpenFileManager('logo')}
                                    sx={{ minWidth: 'auto', px: 2 }}
                                >
                                    Browse
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <TextField
                                    fullWidth
                                    label="Background Image Filename"
                                    value={backgroundImage}
                                    onChange={(e) => onBackgroundImageChange(e.target.value)}
                                    placeholder="Select or enter filename"
                                />
                                <Button
                                    variant="outlined"
                                    startIcon={<FolderIcon />}
                                    onClick={() => onOpenFileManager('background')}
                                    sx={{ minWidth: 'auto', px: 2 }}
                                >
                                    Browse
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
};
